import type { StatusPillVariant } from '../../../components/StatusPill'

/**
 * UX design-stage scaffold (IB-210 Slice 2, demo v66 — see
 * `docs/design/IB-210-cartridge-studio-ui-design.md` §5). Presentational-only:
 * no fetch, no state. The Developer wires this into the real `RuleSet` /
 * `Parameter` / `EligibilityModel` maker-checker flows.
 *
 * The four real, merged lifecycle states (ADR-0054, V37 `cartridge_artifact_status`)
 * shared identically by `RuleSetView.status`, `ParameterView.status`, and
 * `EligibilityModelView.status` — one state machine, one mapping. `CalculationGraph`
 * carries no such status column (ADR-0020, direct-publish) and does not use this map —
 * see `MakerCheckerBar`'s `variant="direct-publish"`.
 */
export type LifecycleStatus = 'draft' | 'review' | 'approved' | 'published'

const VARIANT_BY_STATUS: Record<LifecycleStatus, StatusPillVariant> = {
  draft: 'neutral',
  review: 'warning',
  approved: 'info',
  published: 'success',
}

export function lifecycleStatusPill(status: LifecycleStatus): { variant: StatusPillVariant; label: string } {
  return { variant: VARIANT_BY_STATUS[status], label: status }
}
